import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import { authApi } from "../api/services";

const ATTEMPT_LIMIT = 5;
const LoginUser = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [failedAttempts, setFailedAttempts] = useState(0);
  const [showForgotBanner, setShowForgotBanner] = useState(false);
  
// const handleLogin = async (e) => {
//   e.preventDefault();
//   setIsLoading(true);

//   try {
//     const user = await login(email, password);

//     if (user.role === "super_admin") {
//       navigate("/tenants", { replace: true });
//     } else {
//       navigate("/dashboard", { replace: true });
//     }
//   } catch (error) {
//     const message =
//       error.response?.data?.message || "Login failed. Please try again.";
//     toast.error(message);
//   } finally {
//     setIsLoading(false);
//   }
// };
 const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await authApi.login({ email, password });
      const data = response.data.data;  
      login(data);

      // Reset counters on success
      setFailedAttempts(0);
      setShowForgotBanner(false);

      if (data.user.role === "super_admin") {
        navigate("/tenants", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }

    } catch (error) {
      const status  = error.response?.status;
      const body    = error.response?.data;

      if (status === 403) {
        // Org inactive (or otherwise forbidden) — not a wrong-password attempt,
        // so don't increment the counter; just surface the server message.
        toast.error(body?.message || "Your organization is currently inactive. Please contact your administrator.");
      } else if (status === 429 || body?.hint === "forgot_password") {

        setShowForgotBanner(true);
        setFailedAttempts(ATTEMPT_LIMIT);
        toast.error(body?.message || "Too many failed attempts. Please reset your password.");
      } else {
       
        const newCount = failedAttempts + 1;
        setFailedAttempts(newCount);

        if (newCount >= ATTEMPT_LIMIT) {
          setShowForgotBanner(true);
        }

        const message = body?.message || "Login failed. Please try again.";
        toast.error(message);
      }
    } finally {
      setIsLoading(false);
    }
  };
const handleForgotPassword = () => {
  navigate("/forgot-password",{state:{email}});
};
  return (
    <>
      <Toaster position="top-right" />
      <div className="h-full flex flex-col justify-center items-center px-10">
        <h1 className="text-3xl font-bold text-gray-800 text-center mb-6">
          Login
        </h1>

        {showForgotBanner && (
          <div className="w-full max-w-xs mb-4 p-3.5 bg-amber-50 border border-amber-200
                          rounded-lg flex items-start gap-3">
            
            <svg className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5"
                 fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            </svg>
            <div>
              <p className="text-sm font-semibold text-amber-800">Too many failed attempts</p>
              <p className="text-xs text-amber-700 mt-0.5">
                Please reset your password to regain access.
              </p>
              <button
                type="button"
                onClick={handleForgotPassword}
                className="mt-2 text-xs font-bold text-blue-900 underline underline-offset-2
                           hover:text-blue-700 transition-colors"
              >
                Reset password →
              </button>
            </div>
          </div>
        )}

        <form onSubmit={handleLogin} className="w-full max-w-xs space-y-4">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-blue-900 focus:ring-1 focus:ring-blue-900 transition-colors"
          />
          <div>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={`w-full px-4 py-3 bg-gray-50 border rounded-lg
                         focus:outline-none focus:ring-1 transition-colors
                         ${showForgotBanner
                           ? "border-amber-300 focus:border-amber-500 focus:ring-amber-400"
                           : "border-gray-200 focus:border-blue-900 focus:ring-blue-900"
                         }`}
          />
          {failedAttempts > 0 && failedAttempts < ATTEMPT_LIMIT && (
              <p className="text-xs text-red-500 mt-1.5 text-right">
                {ATTEMPT_LIMIT - failedAttempts} attempt{ATTEMPT_LIMIT - failedAttempts !== 1 ? "s" : ""} remaining
              </p>
            )}
          </div>
      <button
            type="button"
            onClick={handleForgotPassword}
            className={`text-sm text-center block w-full transition-colors
              ${showForgotBanner
                ? "text-blue-900 font-semibold"
                : "text-gray-400 hover:text-blue-900"
              }`}
          >
            Forgot Password?
          </button>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-3 bg-blue-900 text-white font-bold rounded-lg shadow-md hover:bg-blue-800 transition-transform transform active:scale-95 mt-4 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {isLoading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </>
  );
};

export default LoginUser;
